<template>
  <div v-if="uwvDecision">
    <bordered-container title='Nieuwe UWV Beslissing' uwv>
      <table class='confirmation-table confirmation-table-adjust-padding mt-2 mb-2'>
        <tr>
          <td>{{ 'uwv-decision.fields.decision-type' | translate }}</td>
          <td>{{ 'uwv-decision.types.' + uwvDecision.uwvDecisionType | translate }}</td>
        </tr>
        <tr>
          <td>{{ 'uwv-decision.fields.decision-date' | translate }}</td>
          <td>{{ formatDate(stripTime(uwvDecision.decisionDate)) }}</td>
        </tr>
        <tr>
          <td>{{ 'uwv-decision.fields.start-date' | translate }}</td>
          <td>{{ formatDate(stripTime(uwvDecision.startDate)) }}</td>
        </tr>
        <tr>
          <td>{{ 'uwv-decision.fields.disability-rate' | translate }}</td>
          <td>{{ uwvDecision.disabilityRateAsPercentage }} %</td>
        </tr>
        <tr>
          <td>{{ 'uwv-decision.fields.wia-monthly-wage' | translate }}</td>
          <td>{{ formatEuro(uwvDecision.wiaMonthlyWage) }}</td>
        </tr>
        <tr>
          <td>{{ 'uwv-decision.fields.wia-daily-wage' | translate }}</td>
          <td>{{ uwvDecision.wiaDailyWage ? formatEuro(uwvDecision.wiaDailyWage) : '' }}</td>
        </tr>
        <tr>
          <td>{{ 'uwv-decision.fields.benefit-end-date' | translate }}</td>
          <td>{{ formatDate(stripTime(uwvDecision.benefitEndDate)) }}</td>
        </tr>
        <tr>
          <td>{{ 'uwv-decision.fields.income-from-work' | translate }}</td>
          <td>{{ uwvDecision.incomeFromWork ? formatEuro(uwvDecision.incomeFromWork) : '' }}</td>
        </tr>
      </table>
    </bordered-container>
  </div>
</template>

<script>
import Helpers from '@/shared/helpers/functions';
import BorderedContainer from '@aevitae/aevitaeui/0_atoms/containers/BorderedContainer.vue';

export default {
  name: 'WorkStockItemNewUwvDecision',
  components: {
    BorderedContainer
  },
  props: {
    serializedData: String
  },
  computed: {
    uwvDecision () {
      return JSON.parse(this.serializedData).uwvDecision;
    }
  },
  methods: {
    stripTime (datetime) {
      if (datetime != null) {
        return datetime.split('T')[0];
      }
    },

    formatDate (date) {
      if (date != null) {
        return Helpers.Dates.formatDate(date);
      }
    },

    formatEuro (value) {
      if (value != null) {
        return Helpers.Currency.formatCurrency(value.toString().replace(',', '.'));
      }
    }
  }
};
</script>

<style lang='scss' scoped>

.confirmation-table {
  tr {
    &:first-child {
      td {
        border-top: 0;
        padding-top: 0;
      }
    }
    &:last-child {
      td {
        border-bottom: 0;
        padding-bottom: 0;
      }
    }
  }
}
.confirmation-table-adjust-padding {
  td {
    &:first-child {
      padding-left: 14px;
    }
    &:last-child {
      padding-right: 14px;
    }
  }
}
</style>
